import { getAddressFromPostalCode } from 'app/accounts/state/actions'
import { AddressSearchAutocomplete, AddressSearchByIdAutocomplete, AddressSearchResolve } from './address-search/state/actions'
import React from 'react'
import { CountriesDropdownType } from 'core/widgets/CountriesDropdown/enum'
import { CountriesOptionsWrapper } from 'core/widgets/CountriesDropdown/CountriesOptionsWrapper'
import { Address } from '@cbgms/components/form/address/Address'
import { AddressProps } from '@cbgms/components/form/address/types'

const GmsAddress: React.FC<
  Omit<AddressProps, 'getAddressFromPostalCode' | 'actions' | 'countryOptions'> & { countries?: CountriesDropdownType }
> = ({ countries = CountriesDropdownType.all, ...props }) => {
  return (
    <CountriesOptionsWrapper type={countries}>
      {options => (
        <Address
          {...props}
          countryOptions={options}
          getAddressFromPostalCode={getAddressFromPostalCode}
          actions={{ AddressSearchAutocomplete, AddressSearchByIdAutocomplete, AddressSearchResolve }}
        />
      )}
    </CountriesOptionsWrapper>
  )
}

GmsAddress.displayName = 'GmsAddress'
export default GmsAddress
